var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 92,
    viewBox: "0 0 50 92",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M43.827 0H6.172C2.777 0 0 2.777 0 6.172v78.923c0 3.395 2.777 6.172 6.172 6.172h37.655c3.395 0 6.173-2.777 6.173-6.172V6.172C49.999 2.777 47.222 0 43.827 0zM24.999 85.96c-2.122 0-3.852-1.732-3.852-3.853s1.73-3.853 3.853-3.853 3.852 1.73 3.852 3.852S27.122 85.96 25 85.96zm21.234-11.645H3.766V8.035h42.467z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMfa);
export default __webpack_public_path__ + "static/media/add_mfa.009c87ab345b75b6670fce6956f64733.svg";
export { ForwardRef as ReactComponent };